/* eslint-disable import/prefer-default-export */
import { postRequest } from '../helpers/request';

export async function apiGetProducerIntentDashboard(options) {
  return postRequest('/producer_intent/api/get_dashboard/', options);
}
